var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlowerLowHeaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Blower_Low_Speed_Heater_OFF",
    "data-name": "Blower Low Speed_Heater OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 508,
    height: 48,
    viewBox: "0 0 508 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M439.23,34.03a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.3,1.3,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.977,7.977,0,0,1,439.23,34.03Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M439.23,40.99a7.682,7.682,0,0,1-5.21-2.12,1.331,1.331,0,0,1-.01-1.86,1.3,1.3,0,0,1,1.83-.02c.33.32,3.25,2.97,6.93-.08a8.008,8.008,0,0,1,10.7.04,1.321,1.321,0,0,1,.09,1.85,1.278,1.278,0,0,1-1.83.09,5.413,5.413,0,0,0-7.31.04A7.977,7.977,0,0,1,439.23,40.99Z",
    fill: "#b6d3ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M506.38.33H481.47a1.306,1.306,0,0,0-1.3,1.31V6.81a20.92,20.92,0,0,0-13.13,13.77H460.1a1.306,1.306,0,0,0-1.3,1.31V46.36a1.3,1.3,0,0,0,1.3,1.31h25.98v-.04c.28.01.55.04.83.04a20.885,20.885,0,0,0,20.76-21.01c0-.24-.03-.48-.04-.72h.04V1.64A1.3,1.3,0,0,0,506.38.33Z",
    fill: "#b6d3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M486.91,48c-.18,0-.35-.01-.53-.02h-.07l-.22.02H460.1a1.637,1.637,0,0,1-1.62-1.64V21.89a1.63,1.63,0,0,1,1.62-1.64h6.7A21.27,21.27,0,0,1,479.85,6.58V1.64A1.637,1.637,0,0,1,481.47,0h24.91A1.637,1.637,0,0,1,508,1.64l-.02,24.63c.01.13.02.26.02.39A21.238,21.238,0,0,1,486.91,48Zm-.81-.7c.11,0,.22.01.33.02.16.01.32.02.48.02a20.587,20.587,0,0,0,20.44-20.68c0-.14-.01-.27-.02-.4-.01-.1-.01-.2-.02-.31l-.01-.34h.05V1.64a.98.98,0,0,0-.97-.98H481.47a.973.973,0,0,0-.97.98v5.4l-.22.08a20.645,20.645,0,0,0-12.93,13.55l-.07.23H460.1a.973.973,0,0,0-.97.98V46.35a.98.98,0,0,0,.97.98Z",
    fill: "#404041"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M427.23,38.76h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H372.5V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H288.8V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H205.1V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12H189Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.43,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H121.4V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0h-3.22V30.12h3.22Zm-6.44,0H95.64V30.12h3.22Zm-6.43,0H89.21V30.12h3.22Zm-6.44,0H82.77V30.12h3.22Zm-6.44,0H76.33V30.12h3.22Zm-6.44,0H69.89V30.12h3.22Zm-6.44,0H63.45V30.12h3.22Zm-6.44,0H57.01V30.12h3.22Zm-6.44,0H50.57V30.12h3.22Zm-6.43,0H44.14V30.12h3.22Zm-6.44,0H37.7V30.12h3.22v8.64Zm-6.44,0H31.26V30.12h3.22Zm-6.44,0H24.82V30.12h3.22Zm-6.44,0H18.38V30.12H21.6Zm-6.44,0H11.94V30.12h3.22Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9852",
    "data-name": "Group 9852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9851",
    "data-name": "Group 9851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M9.35,39.58,4.29,34.46l5.06-5.12H5.06L0,34.46l5.06,5.12Z",
    fill: "#b6d3ff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlowerLowHeaterOff);
export default __webpack_public_path__ + "static/media/blower_low_heater_off.6f271e799d95848dbaa3785145c5ed27.svg";
export { ForwardRef as ReactComponent };